import React, { useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge,
  CFormCheck,
  CContainer,
  CLink
} from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { insert, update, remove, generateNumber } from 'src/services/Invoices';
import CIcon from '@coreui/icons-react';
import { cilTrash } from '@coreui/icons';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Select, { components } from 'react-select';
import { getAll as getAllSales } from 'src/services/Sales';
import { getAll } from 'src/services/Customers';
import { getAll as getAllBanks } from 'src/services/Banks';
import { getDetails } from 'src/services/Invoices';
import { getForPO } from 'src/services/Products';
import { NumberFormatBase } from 'react-number-format';
import Moment from 'moment';
import formatter from 'src/reusables/formatter';
function InvoiceActions() {
  let today = new Date();
  let todayMonth = today.getMonth() + 1;
  let todayYear = today.getFullYear();
  let todayDate = today.getDate();
  let showToday = todayYear + '-' + todayMonth + '-' + todayDate;
  const d = new Date();
  var month = ('0' + (d.getMonth() + 1)).slice(-2);
  var date = ('0' + d.getDate()).slice(-2);
  var datestringNow = d.getFullYear() + '-' + month + '-' + date;
  const [id, setID] = useState(0);
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedSales, setSelectedSales] = useState({});
  const [salesOptions, setSalesOptions] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(Moment(showToday).format('YYYY-MM-DD'));
  const [grandTotal, setGrandTotal] = useState(0);
  const [gtRolls, setGTRolls] = useState(0);
  const [gtYards, setGTYards] = useState(0);
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [temp, setTemp] = useState(0);
  const [type, setType] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('Cash');
  const [dueDate, setDueDate] = useState(Moment(showToday).format('YYYY-MM-DD'));
  const [selectedBank, setSelectedBank] = useState({});
  const [bankOptions, setBankOptions] = useState([]);
  const [details, setDetails] = useState([
    {
      productID: 0,
      productName: '',
      price: 0,
      qtyRoll: 0,
      qty: 0,
      checked: 0,
      disabledC: 0,
      unitPrice: 0
    }
  ]);
  const [items, setItems] = useState([]);

  const [selected, setSelected] = useState([]);
  const [ban, setBan] = useState([]);
  const [notes, setNotes] = useState('');
  const [uuid, setUUID] = useState('');
  const [initialPayment, setInitialPayment] = useState(0);
  let disabled1 = false;
  let slctd = [];
  let totPrice = 0;
  const dateMax = useState(datestringNow);
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [picName, setPICName] = useState('');
  const [phone, setPhone] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [recipientPhone, setRecipientPhone] = useState('');
  const [recipientAddress, setRecipientAddress] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  // Construct the invoice number
  useEffect(() => {
    if (location.state) {
      setIsEdit(true);
      setID(location.state.id);
      setUUID(location.state.uuid);
      setDueDate(location.state.rawDueDate);
      setNotes(location.state.notes);
      setInvoiceNumber(location.state.invoiceNo);
      setInvoiceDate(location.state.rawInvoiceDate);
      setPaymentMethod(location.state.paymentMethod);
      setRecipientName(location.state.recipientName);
      setRecipientPhone(location.state.recipientPhone);
      setRecipientAddress(location.state.recipientAddress);
      setSelectedCustomer({
        id: location.state.customerID,
        label: location.state.customerName,
        value: location.state.customerID
      });
      setSelectedBank({
        id: location.state.bankID,
        label: location.state.bankName,
        value: location.state.bankID
      });
      setSelectedSales({
        id: location.state.salesID,
        label: location.state.salesName,
        value: location.state.salesID
      });
      fetchDetails(location.state.id);
    }

    fetchCustomers();
    fetchSales();
    fetchBanks();
    fetchProducts();
  }, [location.state]);

  useEffect(() => {
    if (type !== 1) {
      let total = 0;
      let totalRolls = 0;
      let totalYards = 0;
      details.length > 0 &&
        details.forEach((item) => {
          total += item.price;
          totalRolls += item.qtyRoll;
          totalYards += item.qty;
          setGrandTotal(total);
          setGTRolls(totalRolls);
          setGTYards(totalYards);
        });
    }
  }, [details]);
  const fetchDetails = async (x) => {
    let response = await getDetails(x);

    if (response.success === 1) {
      let data =
        response?.details.map((item) => {
          return {
            id: item.id,

            productID: item.productID,
            productName: item.productName,
            qtyRoll: item.qty_roll,
            qty: item.qty_pcs,
            unitPrice: item.unit_price,
            price: item.qty_pcs * item.unit_price
          };
        }) ?? [];

      setDetails(data);
    }
  };
  const fetchCustomers = async () => {
    let response = await getAll();

    if (response.success === 1) {
      let data =
        response?.customers.map((item) => {
          return {
            id: item.id,
            label: `${item.name}`,
            value: item.id
          };
        }) ?? [];
      data.push({
        id: 0,
        label: `Customer Baru`,
        value: 0
      });
      setCustomerOptions(data);
    }
  };
  const fetchBanks = async () => {
    let response = await getAllBanks();

    if (response.success === 1) {
      let data =
        response?.banks.map((item) => {
          return {
            id: item.id,
            label: `${item.name}`,
            value: item.id
          };
        }) ?? [];

      setBankOptions(data);
    }
  };
  const fetchSales = async () => {
    let response = await getAllSales();

    if (response.success === 1) {
      let data =
        response?.sales.map((item) => {
          return {
            id: item.id,
            label: `${item.name}`,
            value: item.id
          };
        }) ?? [];

      setSalesOptions(data);
    }
  };
  const fetchProducts = async () => {
    let response = await getForPO();

    if (response.success === 1) {
      let data =
        response?.products.map((item) => {
          return {
            id: item.id,
            label: `${item.name}`,
            value: item.id,
            price_per_yards: item.price_per_yards,
            name: 'items',
            type: 'menu',
            target: {
              label: `${item.name}`,
              id: item.id,
              value: item.id,
              price_per_yards: item.price_per_yards,
              name: 'items',
              type: 'menu'
            }
          };
        }) ?? [];

      setItems(data);
    }
  };
  async function fDelete() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(response?.data?.message);
        setOpen(true);
        setColor('red');
      }
    });
  }
  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false) {
    } else {
      setSaveLoading(true);
      let data = {
        id: id,
        customerID: selectedCustomer.value,
        bankID: selectedBank.value,
        salesID: selectedSales.value,
        paymentMethod: paymentMethod,
        invoiceDate: invoiceDate,
        notes: notes,
        dueDate: dueDate,
        initialPayment: initialPayment,
        details: details,
        grandTotal: grandTotal,
        gtRolls: gtRolls,
        gtYards: gtYards,
        name: name,
        address: address,
        picName: picName,
        phone: phone,
        recipientName: recipientName,
        recipientPhone: recipientPhone,
        recipientAddress: recipientAddress
      };
      if (location.state) {
        await update(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);
            data();
            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message);
            setOpen(true);
            setColor('red');
          }
        });
      } else {
        await insert(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            window.open('https://printer.movejuicetex.id/DeliveryOrder.php?uuid=' + response.data.invoiceUUID, '_blank');
            window.open('https://printer.movejuicetex.id/Invoices.php?uuid=' + response.data.invoiceUUID, '_blank');
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);
            data();
            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message ?? ls.get('errorMessage'));
            setOpen(true);
            setColor('red');
          }
        });
      }
    }
    setValidated(true);

    // e.preventDefault()
    // console.log('bener')
  }
  const handleDetailsChange = (e, index) => {
    const list = [...details];
    const { name, value } = e.target;

    if (name === 'unitPrice') {
      list[index]['price'] = parseFloat((value * list[index]['qty']).toFixed(2));
      list[index]['unitPrice'] = parseFloat(value).toFixed(2);
    } else if (name === 'items') {
      list[index]['productID'] = value;
      list[index]['productName'] = e.target.label;

      list[index]['qty'] = 1;
      list[index]['qtyRoll'] = 1;
      list[index]['price'] = e.target.price_per_yards * list[index]['qty'];
      list[index]['unitPrice'] = e.target.price_per_yards;
    } else if (name === 'qty') {
      list[index]['price'] = list[index]['unitPrice'] * value;
      list[index][name] = value;
    } else {
      list[index][name] = value;
    }
    setDetails(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...details];
    list.splice(index, 1);
    setDetails(list);
  };

  const handleAddClick = () => {
    setDetails([
      ...details,
      {
        productID: 0,
        productName: '',

        checked: 0,

        price: 0,
        qty: 0,
        qtyRoll: 0,
        disabledC: 0
      }
    ]);
  };
  return (
    <CCard>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />
      <CCardHeader>Actions - Invoice</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Nomor Invoice</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                disabled
                value={invoiceNumber}
                onChange={(e) => setInvoiceNumber(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Tanggal Invoice</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="date"
                value={invoiceDate}
                max={Moment(showToday).format('YYYY-MM-DD')}
                onChange={(e) => setInvoiceDate(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>{' '}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Customer</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Cabang"
                value={selectedCustomer}
                options={customerOptions}
                onChange={(e) => {
                  setSelectedCustomer(e);
                }}
                isDisabled={false}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          {selectedCustomer.value === 0 ? (
            <div>
              <CRow className="mb-3">
                <CCol md={3}>
                  <CFormLabel>Nama</CFormLabel>&nbsp;
                  <CBadge color="warning">Wajib</CBadge>
                </CCol>
                <CCol>
                  <CFormInput
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    feedbackInvalid="Required value"
                    required
                  />
                </CCol>
              </CRow>
              <CRow className="mb-3">
                <CCol md={3}>
                  <CFormLabel>Nama PIC / Owner</CFormLabel>&nbsp; <CBadge color="warning">Wajib</CBadge>
                </CCol>
                <CCol>
                  <CFormInput
                    type="text"
                    value={picName}
                    onChange={(e) => setPICName(e.target.value)}
                    feedbackInvalid="Required value"
                    required
                  />
                </CCol>
              </CRow>{' '}
              <CRow className="mb-3">
                <CCol md={3}>
                  <CFormLabel>Alamat</CFormLabel>&nbsp; <CBadge color="warning">Wajib</CBadge>
                </CCol>
                <CCol>
                  <CFormInput
                    type="text"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    feedbackInvalid="Required value"
                    required
                  />
                </CCol>
              </CRow>{' '}
              <CRow className="mb-3">
                <CCol md={3}>
                  <CFormLabel>HP</CFormLabel>&nbsp; <CBadge color="warning">Wajib</CBadge>
                </CCol>
                <CCol>
                  <CFormInput
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    feedbackInvalid="Required value"
                    required
                  />
                </CCol>
              </CRow>
            </div>
          ) : (
            <div></div>
          )}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Sales</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Sales"
                value={selectedSales}
                options={salesOptions}
                onChange={(e) => {
                  setSelectedSales(e);
                }}
                isDisabled={false}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Tipe Pembayaran</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormCheck
                inline
                type="radio"
                label="Cash"
                checked={paymentMethod === 'Cash'}
                defaultChecked
                className="mx-3"
                onChange={() => [setPaymentMethod('Cash')]}
              />
              <CFormCheck
                inline
                type="radio"
                label="Tempo"
                checked={paymentMethod === 'Tempo'}
                onChange={() => [setPaymentMethod('Tempo')]}
              />
              <br />
              <CFormLabel>*Receipt otomatis terbuat sesuai nominal pembayaran saat ini</CFormLabel>
            </CCol>
          </CRow>
          {paymentMethod === 'Tempo' ? (
            <div>
              <CRow className="mb-3">
                <CCol md={3}>
                  <CFormLabel>Tanggal Jatuh Tempo</CFormLabel>&nbsp;
                  <CBadge color="warning">Wajib</CBadge>
                </CCol>
                <CCol>
                  <CFormInput
                    type="date"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                    feedbackInvalid="Required value"
                    required
                  />
                </CCol>
              </CRow>{' '}
              {isEdit ? (
                <div></div>
              ) : (
                <CRow className="mb-3">
                  <CCol md={3}>
                    <CFormLabel>Pembayaran Awal</CFormLabel>&nbsp;
                    <CBadge color="warning">Wajib</CBadge>
                  </CCol>
                  <CCol>
                    <CFormInput
                      type="number"
                      value={initialPayment}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => setInitialPayment(e.target.value)}
                    />
                  </CCol>
                </CRow>
              )}
            </div>
          ) : (
            <div></div>
          )}
          {isEdit ? (
            <div></div>
          ) : (
            <CRow className="mb-3">
              <CCol md={3}>
                <CFormLabel>Bank</CFormLabel>&nbsp;
                <CBadge color="warning">Wajib</CBadge>
              </CCol>
              <CCol>
                <Select
                  placeholder="Pilih Bank"
                  value={selectedBank}
                  options={bankOptions}
                  onChange={(e) => {
                    setSelectedBank(e);
                  }}
                  isDisabled={false}
                  feedbackInvalid="Required value"
                  required
                />
              </CCol>
            </CRow>
          )}
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Catatan</CFormLabel>&nbsp;
            </CCol>
            <CCol>
              <CFormInput type="text" value={notes} onChange={(e) => setNotes(e.target.value)} />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Nama Penerima</CFormLabel>&nbsp;
            </CCol>
            <CCol>
              <CFormInput type="text" value={recipientName} onChange={(e) => setRecipientName(e.target.value)} />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>HP Penerima</CFormLabel>&nbsp;
            </CCol>
            <CCol>
              <CFormInput type="text" value={recipientPhone} onChange={(e) => setRecipientPhone(e.target.value)} />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Alamat Penerima</CFormLabel>&nbsp;
            </CCol>
            <CCol>
              <CFormInput type="text" value={recipientAddress} onChange={(e) => setRecipientAddress(e.target.value)} />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol lg="3">
              <CFormLabel htmlFor="name">Daftar Barang</CFormLabel>
            </CCol>
            <CCol xs="12" lg="9"></CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xs="12" lg="12">
              <CRow>
                <CCol xs="5" className="pl-4">
                  Item
                </CCol>
                <CCol xs="1">Qty (Roll)</CCol>
                <CCol xs="1">Qty (Yard)</CCol>

                <CCol xs="2">Harga Satuan</CCol>
                <CCol xs="2">Total Harga</CCol>
                <CCol xs="1"></CCol>
              </CRow>
              {details &&
                details.map(({ id, qtyRoll, qty, price, productID, productName, checked, disabledC }, index) => {
                  let disD = false;
                  let unitPrice = price / qty;
                  let item = {
                    id: productID,
                    value: productID,
                    label: productName,
                    type: 'product',
                    id_product: productID,
                    qtyRoll: qtyRoll,
                    qty: qty,

                    checked: checked
                  };

                  if (!productID && disabled1 === false) {
                    disabled1 = true;
                  }
                  if (checked === 1 && disabledC === 0) {
                    slctd.push({ item: item });
                  }
                  totPrice += parseFloat(price);
                  let index1 = index;
                  return (
                    <>
                      <CCol>
                        &nbsp;
                        <CRow key={index}>
                          <CCol xs="5">
                            <Select
                              options={items}
                              name="item"
                              isDisabled={isEdit}
                              placeholder="Pilih item"
                              value={item}
                              onChange={(e) => handleDetailsChange(e, index)}
                            />
                          </CCol>
                          <CCol xs="1">
                            <NumberFormatBase
                              // isDisabled={isEdit}
                              // disabled=
                              disabled={isEdit}
                              style={{
                                height: '100%',
                                width: '100%',
                                border: '1px solid lightgray',
                                borderRadius: '3px',
                                paddingLeft: '10px',
                                paddingRight: '10px'
                              }}
                              value={qtyRoll}
                              thousandSeparator={'.'}
                              decimalSeparator={','}
                              onValueChange={(e) => {
                                const list = [...details];
                                if (e.floatValue) {
                                  // list[index]['price'] = list[index]['unitPrice'] * e.floatValue;
                                  list[index]['qtyRoll'] = e.floatValue;
                                } else {
                                  // list[index]['price'] = NaN;
                                  list[index]['qtyRoll'] = '';
                                }

                                setDetails(list);
                              }}
                            />

                            {/* <CFormInput type="number" onWheel={(e) => e.target.blur()} disabled={type===1?true:false} placeholder="0" name="qty" value={qty} onChange={(e) => handleDetailsChange(e, index)}/> */}
                          </CCol>
                          <CCol xs="1">
                            <NumberFormatBase
                              // isDisabled={isEdit}
                              // disabled=
                              disabled={isEdit}
                              style={{
                                height: '100%',
                                width: '100%',
                                border: '1px solid lightgray',
                                borderRadius: '3px',
                                paddingLeft: '10px',
                                paddingRight: '10px'
                              }}
                              value={qty}
                              thousandSeparator={'.'}
                              decimalSeparator={','}
                              onValueChange={(e) => {
                                const list = [...details];
                                if (e.floatValue) {
                                  list[index]['price'] = list[index]['unitPrice'] * e.floatValue;
                                  list[index]['qty'] = e.floatValue;
                                } else {
                                  list[index]['price'] = NaN;
                                  list[index]['qty'] = '';
                                }

                                setDetails(list);
                              }}
                            />

                            {/* <CFormInput type="number" onWheel={(e) => e.target.blur()} disabled={type===1?true:false} placeholder="0" name="qty" value={qty} onChange={(e) => handleDetailsChange(e, index)}/> */}
                          </CCol>

                          <CCol xs="2">
                            <CFormInput
                              onWheel={(e) => e.target.blur()}
                              disabled={isEdit}
                              placeholder="0"
                              type="number"
                              // type='text'
                              name="unitPrice"
                              value={unitPrice ? parseFloat(unitPrice.toFixed(2)) : ''}
                              onChange={(e) => {
                                handleDetailsChange(e, index);
                              }}
                            />
                          </CCol>
                          <CCol xs="2">
                            <NumberFormatBase
                              disabled={true}
                              style={{
                                height: '100%',
                                width: '100%',
                                border: '1px solid lightgray',
                                borderRadius: '3px',
                                paddingLeft: '10px',
                                paddingRight: '10px'
                              }}
                              value={price ? parseFloat(price.toFixed(2)) : ''}
                              thousandSeparator={'.'}
                              decimalSeparator={','}
                            />
                          </CCol>

                          <CCol xs="1" hidden={isEdit}>
                            {details.length !== 1 && (
                              <CButton color="danger" onClick={() => handleRemoveClick(index)}>
                                <span style={{ color: 'white' }}> -</span>
                              </CButton>
                            )}
                          </CCol>
                        </CRow>
                      </CCol>
                    </>
                  );
                })}
              <br />
              {isEdit ? (
                <div></div>
              ) : (
                <CRow row>
                  <CCol xs="10"></CCol>
                  <CCol xs="2">
                    <CButton color="primary" onClick={handleAddClick}>
                      Tambah
                    </CButton>
                  </CCol>
                </CRow>
              )}
              <CRow>
                <CCol xs="9">
                  <p
                    style={{
                      textAlign: 'end',
                      fontWeight: 600,
                      fontSize: 16
                    }}
                  >
                    Grand Total:
                  </p>
                </CCol>
                <CCol xs="3">
                  <p
                    style={{
                      fontWeight: 600,
                      fontSize: 16
                    }}
                  >
                    {formatter('currency', grandTotal || grandTotal === '0' ? grandTotal : grandTotal)}
                  </p>
                </CCol>
              </CRow>
              <CRow>
                <CCol xs="9">
                  <p
                    style={{
                      textAlign: 'end',
                      fontWeight: 600,
                      fontSize: 16
                    }}
                  >
                    Total Yard:
                  </p>
                </CCol>
                <CCol xs="2">
                  <p
                    style={{
                      fontWeight: 600,
                      fontSize: 16
                    }}
                  >
                    {formatter('number', gtYards || gtYards === '0' ? gtYards : gtYards)}
                  </p>
                </CCol>
              </CRow>
              <CRow>
                <CCol xs="9">
                  <p
                    style={{
                      textAlign: 'end',
                      fontWeight: 600,
                      fontSize: 16
                    }}
                  >
                    Total Rolls:
                  </p>
                </CCol>
                <CCol xs="2">
                  <p
                    style={{
                      fontWeight: 600,
                      fontSize: 16
                    }}
                  >
                    {formatter('number', gtRolls || gtRolls === '0' ? gtRolls : gtRolls)}
                  </p>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
        <CCardFooter style={{ textAlign: 'right' }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                fDelete();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: 'black',
              backgroundColor: 'white'
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            {isEdit ? 'Back' : 'Cancel'}
          </CButton>
          &emsp;
          {isEdit ? (
            <CLink
              className="c-subheader-nav-link"
              href={'https://printer.movejuicetex.id/Invoices.php?uuid=' + uuid}
              target="_blank"
            >
              <CButton
                color="success"
                style={{
                  color: 'white'
                }}
              >
                Print Invoice
              </CButton>
            </CLink>
          ) : (
            <div></div>
          )}
          &emsp;
          {isEdit ? (
            <CLink
              className="c-subheader-nav-link"
              href={'https://printer.movejuicetex.id/DeliveryOrder.php?uuid=' + uuid}
              target="_blank"
            >
              <CButton
                color="success"
                style={{
                  color: 'white'
                }}
              >
                Print Surat Jalan
              </CButton>
            </CLink>
          ) : (
            <CButton
              color="success"
              style={{
                color: 'white'
              }}
              type="submit"
              disabled={saveLoading}
            >
              Save
            </CButton>
          )}
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default InvoiceActions;
